export default {
      id: "spin-control-off-usage",
      viewBox: "0 0 480.4 480.56",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#spin-control-off-usage",
      toString: function () {
        return this.url;
      }
    }